<template>
  <v-autocomplete class="body-1" flat background-color="transparent" hide-details :items="items" readonly solo
    v-model="model[`${prop.value}`]" single-line full-width append-icon="" browser-autocomplete
    :item-text="prop.sourceItemText" :item-value="prop.sourceItemValue" :loading="loading"
    style="margin: 0px;padding: 0px;">
  </v-autocomplete>
</template>

<style scoped>

</style>

<script>
  import CellSelection from "./cellSelection.ts";
  export default CellSelection;
</script>